"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiGetValidUserEmailDomains = exports.apiGetValidAdminEmailDomains = exports.apiSetMeta = exports.apiLogout = exports.apiLoginStudent = exports.apiLoginTeacher = exports.apiLogin = exports.apiGetSelf = exports.isStudent = exports.isTeacher = void 0;
const client_1 = require("./client");
const students_1 = require("./students");
const teachers_1 = require("./teachers");
const util_1 = require("./util");
/**
 * Check if the user is a teacher.
 * @param u The user to check.
 * @returns
 */
const isTeacher = (u) => u.email !== undefined;
exports.isTeacher = isTeacher;
/**
 * Check if the user is a student.
 * @param u the user to check.
 * @returns
 */
const isStudent = (u) => u.isActivated !== undefined;
exports.isStudent = isStudent;
/**
 * Get the current user based on the stored access token
 * @returns the user or null if the access token was found
 */
const apiGetSelf = async () => {
    const { data } = await client_1.default.get('/auth/self');
    return data;
};
exports.apiGetSelf = apiGetSelf;
/**
 * Login a user. Attempts to match the credentials against a teacher, then a student.
 * @param loginName
 * @param password
 * @returns either a teacher or student.
 */
const apiLogin = async (loginName, password) => {
    try {
        const { data } = await client_1.default.post('/auth/login/teacher', {
            username: loginName,
            password,
        });
        return Object.assign(Object.assign({}, data), { type: 'teacher' });
    }
    catch (_a) {
        const { data } = await client_1.default.post('/auth/login/student', {
            username: loginName,
            password,
        });
        return Object.assign(Object.assign({}, data), { type: 'student' });
    }
};
exports.apiLogin = apiLogin;
/**
 * Authenticate a teacher.
 * @param loginName the login name or email of the teacher..
 * @param password the password of the teacher.
 * @returns {ILoginResponse} the user and the JWT access token.
 */
const apiLoginTeacher = async (loginName, password) => {
    try {
        const { data } = await client_1.default.post('/auth/login/teacher', {
            username: loginName,
            password,
        });
        return data;
    }
    catch (error) {
        throw (0, util_1.handleError)(error);
    }
};
exports.apiLoginTeacher = apiLoginTeacher;
/**
 * Authenticate a student.
 * @param loginName the login name of the student.
 * @param password the password of the student.
 * @returns {ILoginResponse} the Student and the JWT access token.
 */
const apiLoginStudent = async (loginName, password) => {
    const { data } = await client_1.default.post('/auth/login/student', {
        username: loginName,
        password,
    });
    return data;
};
exports.apiLoginStudent = apiLoginStudent;
/**
 * Logout the current logged in user.
 */
const apiLogout = async () => {
    await client_1.default.post('/auth/logout');
};
exports.apiLogout = apiLogout;
/**
 * Set the meta-data for currenty logged in user.
 *
 * The data will be overwritten, so you will have to add the old
 * values via e.g. spreading.
 * @param meta the meta data to set
 * @returns the updated user.
 */
const apiSetMeta = async (meta) => {
    if ((0, util_1.isStudentUser)()) {
        return (0, students_1.apiSetStudentMeta)(meta);
    }
    return (0, teachers_1.apiSetTeacherMeta)(meta);
};
exports.apiSetMeta = apiSetMeta;
/**
 * returns a string array with all email-domains that are valid for ADMINS.
 * Each entry also contains the '@' character at the beginning.
 * @returns a string array of all valid ADMIN email domains
 */
const apiGetValidAdminEmailDomains = async () => {
    try {
        const { data } = await client_1.default.get('/auth/valid-admin-email-domains');
        return data;
    }
    catch (e) {
        throw (0, util_1.handleError)(e);
    }
};
exports.apiGetValidAdminEmailDomains = apiGetValidAdminEmailDomains;
/**
 * returns a string array with all email-domains that are valid for USERS.
 * Each entry also contains the '@' character at the beginning.
 * @returns a string array of all valid USER email domains
 */
const apiGetValidUserEmailDomains = async () => {
    try {
        const { data } = await client_1.default.get('/auth/valid-user-email-domains');
        return data;
    }
    catch (e) {
        throw (0, util_1.handleError)(e);
    }
};
exports.apiGetValidUserEmailDomains = apiGetValidUserEmailDomains;
//# sourceMappingURL=auth.js.map